import { from } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import {
  FETCH_ARTICLE_DESCRIPTION,
  fetchArticleDescriptionFulfilled,
  fetchArticleDescriptionError,
} from "redux/actions/articleDescription";
import { gqlQuery } from "libs/awsLib";
import { queryArticleDescription } from "gql/index";


/* EPICS */
export const fetchArticleDescriptionEpic = action$ => action$.pipe(
  ofType(FETCH_ARTICLE_DESCRIPTION),
  mergeMap(({ payload }) =>
    from(
      gqlQuery(queryArticleDescription, payload)
        .then(response => {return { ...response.articleDescription, ...payload };})
        .then(fetchArticleDescriptionFulfilled)
        .catch(fetchArticleDescriptionError)
    )
  )
);

